import { gql, useMutation } from "@apollo/client";

const DeleteChartMutation = gql`
  mutation deleteChart($input: DeleteChartInput!) {
    deleteChart(input: $input) {
      deletedChartID
    }
  }
`;

export const useDeleteChartMutation = () =>
  useMutation<
    {
      deleteChart: {
        deletedChartID: string;
      };
    },
    {
      input: {
        chartID: string;
      };
    }
  >(DeleteChartMutation);
